/**
 * ID format detection utilities.
 *
 * Used to distinguish between GUID (UUID v4) identifiers and NanoID-based
 * short identifiers when routing API calls.
 */

const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Returns true if the given string matches the GUID/UUID format
 * (8-4-4-4-12 hex digits with dashes).
 */
export function isGuid(value: string): boolean {
  return GUID_PATTERN.test(value);
}
